import { Box } from '@chakra-ui/react';
import * as React from 'react';

import { useWindowHeight } from '@/hooks/useWindowHeight';
import {
  Blueprint,
  BlueprintPortal,
  useBlueprint,
} from '@/layouts/components/Blueprint';

export const DobermanPincerMain: React.FC<{ isFullWidth?: boolean }> = (
  props
) => {
  return (
    <Box as="main" p="4" flex="1">
      <Box maxW="container.xl" mx="auto">
        {props.children}
      </Box>
    </Box>
  );
};

export const DobermanPincerAside: React.FC = (props) => {
  const windowHeight = useWindowHeight();
  const { headerHeight } = useBlueprint();

  return (
    <Box
      w={{ base: 'full', md: 'md', lg: 'lg' }}
      as="aside"
      display={{ base: 'none', md: 'block' }}
      alignSelf="flex-start"
      h={`${windowHeight - headerHeight}px`}
      position="sticky"
      top={`${headerHeight}px`}
    >
      {props.children}
    </Box>
  );
};

export const DobermanPincerPortal = BlueprintPortal;

export const DobermanPincer: React.FC = (props) => {
  return (
    <Blueprint isHeaderContained={false}>
      <Box display="flex">{props.children}</Box>
    </Blueprint>
  );
};
